import React, { type ReactNode } from "react";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, Configure, InstantSearchSSRProvider, type InstantSearchServerState } from "react-instantsearch";
import { AlgoliaInsightsMiddleware } from "./search-insights";

type SearchProviderProps = {
  appId: string;
  searchApiKey: string;
  children: ReactNode;
  serverState?: InstantSearchServerState;
  filters?: string;
};

export function AlgoliaSearchProvider({ appId, searchApiKey, children, serverState, filters }: SearchProviderProps) {
  const searchClient = algoliasearch(appId, searchApiKey);

  return (
    <InstantSearchSSRProvider {...serverState}>
      <InstantSearch searchClient={searchClient} indexName={`${process.env.NEXT_PUBLIC_ALGOLIA_INDEX}`}>
        <Configure distinct exactOnSingleWordQuery="none" filters={filters} hitsPerPage={999} page={0} />
        <AlgoliaInsightsMiddleware />
        {children}
      </InstantSearch>
    </InstantSearchSSRProvider>
  );
}
